/**
 * UI click/toggle sound.
 *
 * A single shared sample (Switch_02.wav) played whenever an interactable menu
 * element is activated — buttons, checkboxes, the spawn <select>. Deliberately
 * independent of the per-scenario AudioManager (which is bound to the 3D
 * listener + engine and is torn down / rebuilt between scenarios): the menus
 * exist outside any scenario, so this uses a plain HTMLAudioElement instead.
 *
 * The element is cloned per play so rapid clicks overlap rather than cutting
 * each other off. Playback is gated behind the user's click, so it sidesteps
 * the browser autoplay policy.
 */

import { audioUrl } from '../audio/soundManifest.js';

const SRC = audioUrl('assets/sound/Switch_02.wav');
const VOLUME = 0.4;

let template = null;

/** Preload the sample. Safe to call multiple times. */
export function initUISound() {
  if (template) return;
  template = new Audio(SRC);
  template.preload = 'auto';
  template.volume = VOLUME;
}

/** Play a one-shot UI click. Overlapping clicks each get their own voice. */
export function playUIClick() {
  if (!template) initUISound();
  const voice = template.cloneNode();
  voice.volume = VOLUME;
  voice.play().catch(() => { /* autoplay blocked / interrupted — ignore */ });
}
